import { render, staticRenderFns } from "./SatisfacaoDoCidadao.vue?vue&type=template&id=024164fd"
import script from "./SatisfacaoDoCidadao.vue?vue&type=script&lang=js"
export * from "./SatisfacaoDoCidadao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports